import React, { useReducer, createContext, useContext } from "react";
const INIT_PAGE = 1;
const INVESTCO_TYPE = "1";
const ACTIONS = {
  SORT: "SORT",
  SEARCH: "SEARCH",
  REFRESH: "REFRESH",
  PAGE_CHANGE: "PAGE_CHANGE",
  PAGE_SIZE_CHANGE: "PAGE_SIZE_CHANGE",
  GET_DISTRIBUTIONS_SUCCESS: "GET_DISTRIBUTIONS_SUCCESS",
};

const initialState = {
  sizePerPage: "All",
  page: INIT_PAGE,
  search: "",
  sortBy: "id",
  direction: "asc",
  status: null,
  fundQuarterId: null,
  programId: null,
  distributionType: INVESTCO_TYPE,
  distributions: { data: [] },
};

let reducer = (state, data) => {
  switch (data.action) {
    case ACTIONS.GET_DISTRIBUTIONS_SUCCESS: {
      const { payload } = data;
      const { distributions } = payload;

      return {
        ...state,
        distributions,
      };
    }

    case ACTIONS.SORT: {
      const { payload } = data;
      const { sortBy, direction } = payload;

      return {
        ...state,
        sortBy,
        direction,
        page: INIT_PAGE,
      };
    }

    case ACTIONS.SEARCH: {
      const { payload } = data;
      const { search } = payload;

      return {
        ...state,
        search,
        page: INIT_PAGE,
      };
    }

    case ACTIONS.REFRESH:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case ACTIONS.PAGE_CHANGE: {
      const { payload } = data;
      const { page } = payload;
      return {
        ...state,
        page,
      };
    }

    case ACTIONS.PAGE_SIZE_CHANGE: {
      const { payload } = data;
      const { sizePerPage } = payload;
      return {
        ...state,
        sizePerPage,
        page: INIT_PAGE,
      };
    }

    default:
      return { ...state, ...data };
  }
};

const DistributionsContext = createContext(initialState);

const DistributionsProvider = ({ children }) => {
  const stateAndDispatch = useReducer(reducer, initialState);
  return (
    <DistributionsContext.Provider value={stateAndDispatch}>
      {children}
    </DistributionsContext.Provider>
  );
};

export const useDistributions = () => useContext(DistributionsContext);

export { DistributionsContext, DistributionsProvider, ACTIONS };
